import React, { useCallback, useMemo, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { withDependencies } from 'gw-portals-dependency-react';
import { ViewModelForm, withViewModelService } from 'gw-portals-viewmodel-react';
import { useModal } from '@jutro/components';
import metadata from './AdacConfirmationPage.metadata.json5';
import styles from './AdacConfirmationPage.module.scss';
import messages from './AdacConfirmationPage.messages';
import AdacConfirmationModal from '../../components/AdacConfirmationModal';

function AdacConfirmationPage(props) {
    const {
        history: { location: { state } }
    } = props;
    const translator = useTranslator();
    const { callbackOption } = state || {};

    const makePhoneCall = useCallback((event) => {
        event.preventDefault();
        window.location = 'tel:+4989767676';
    }, []);
    const { showModal } = useModal();

    const getData = useCallback(() => {
        showModal(
            <AdacConfirmationModal
                message={translator(messages.confirmationSuccess)}
                confirmButtonText={translator(messages.confirmationClose)}
            />
        );
    }, [showModal, translator]);

    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const overrideProps = useMemo(() => ({
        callbackInformation: {
            content: translator(messages.callbackInformation, { callbackOption })
        },
    }), [callbackOption, translator]);

    const resolvers = {
        resolveCallbackMap: {
            makePhoneCall
        },
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

AdacConfirmationPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired
};

export default withRouter(withViewModelService(withDependencies(['ClaimService'])(AdacConfirmationPage)));
